module.exports = __webpack_public_path__ + "static/media/cr_3.b72dad49.png";